import { render, staticRenderFns } from "./_topickeyword.vue?vue&type=template&id=823dc45e&scoped=true"
import script from "./_topickeyword.vue?vue&type=script&lang=js"
export * from "./_topickeyword.vue?vue&type=script&lang=js"
import style0 from "./_topickeyword.vue?vue&type=style&index=0&id=823dc45e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823dc45e",
  null
  
)

export default component.exports